export const BLOCKED_NOTICE_STRINGS = {
	BLOCKED_SELLING_MESSAGE: 'Você bloqueou este usuário. Para retomar a conversa, será necessário desbloqueá-lo.',
	BLOCKED_BUYING_MESSAGE: 'O vendedor não está avaliando novas propostas no momento.',
	WARNING_ICON_ALT: 'Aviso',
} as const;
